import React from 'react';
import {
  hasDismissedAlert,
  AlertRulesEngineOptions,
} from 'src/helpers/alerts/index.ts';
import { Rule } from 'src/helpers/rulesEngine';
import Alert from 'src/components/Alert/';
import { isActive } from 'src/helpers/page';
import { FormattedMessage } from 'react-intl';

const VerifiedAlert: Rule<JSX.Element, AlertRulesEngineOptions> = (
  state,
  options
) => {
  const { verificationStatus, status } = state.page;
  const alertKey = 'identity_verified';

  if (
    isActive({ status }) &&
    verificationStatus === 'Verified' &&
    !hasDismissedAlert(state.page.id, alertKey)
  ) {
    return {
      matched: true,
      result: (
        <Alert
          id={alertKey}
          type="green"
          onClose={options!.onClose}
          page={state.page}
          autoCloseMs={5000}
        >
          <p className="jg-space-mbn">
            <FormattedMessage
              id="VerifiedAlert.text"
              defaultMessage="Youʼre all up to date."
            />
          </p>
        </Alert>
      ),
    };
  }

  return { matched: false };
};

export default VerifiedAlert;



// WEBPACK FOOTER //
// ./src/helpers/alerts/VerifiedAlert.tsx